'use client';

import OrderInformation from '@components/order/order-information';
import Container from '@components/ui/container';
import Divider from '@components/ui/divider';
import {useRouteLang} from "src/hooks/use-route-lang";

export default function OrderContent() {
    const lang = useRouteLang();
    return (
    <>
      <Divider />
      <Container>
        <OrderInformation lang={lang} />
      </Container>
      <Divider />
    </>
  );
}
